import { Component, OnChanges, Output, Input, EventEmitter, ElementRef } from '@angular/core';
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { CommonService } from "../../_services/common.service";
import { Router } from '@angular/router';
import { FlashMessagesService } from "angular2-flash-messages";
import { MatDialog } from "@angular/material";
import { StoreProductPriceComponent } from '../../mnt-stores/store-product-price/store-product-price.component';

@Component({
  selector: 'app-add-product-step',
  templateUrl: './add-product-step.component.html',
  styleUrls: ['./add-product-step.component.css']
})
export class AddProductStepComponent implements OnChanges {
  @Output() clickOnLink = new EventEmitter();
  @Input() totalQuantity: number;
  @Input() totalPrice: number;
  @Input() orderType: string;
  @Input() redirectClick: string;
  @Input() customOrderId: string;
  public activeLink: string;
  public redirectUrl = null;
  public activeProjectIndex = null;
  public projects: any = {};
  public selectedProductColors = {};
  public selectedColors: any = [];
  public min_order_qty = null;
  private errorMsg = null;
  public inkTypeLists: Array<any> = [];
  public isShowInkType = false;
  public finishingStepNo = 5;
  public finalStepNo = 6;
  public isShowFinishingType = false;
  public isShowPayment = false;
  public OrderId: string;
  public customOrderID: string;
  public ClientName: string = '';
  public deliveryDate: string;
  public userDetails: any = {};
  public clientId: string;
  public checkQtyToUrl: string;
  public companyName: string;
  public storeId: string;
  public currentIndexForStep = 1;
  public previousIndexForStep = 1;
  public isPublicQuoteCreation = false;
  public clientFullName: string = '';
  public isCustomer = false;
  public boxLabel = true;
  public deliveryDateForPicker: Date;
  public scheduledDate: string = '';

  constructor(private CommonProjectDataService: CommonProjectDataService,
    public dialog: MatDialog,
    private router: Router,
    private elementRef: ElementRef,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService) {
    this.isPublicQuoteCreation = localStorage.getItem('isPublicQuoteCreation') === 'Yes' ? true : false;
  }


  ngOnInit() {
    this.deliveryDate = this.CommonProjectDataService.getDeliveryDate();
    this.OrderId = this.CommonProjectDataService.getOrderId();
    this.customOrderID = this.CommonProjectDataService.getCustomOrderId();
    this.ClientName = this.CommonProjectDataService.getclientName();
    this.companyName = this.CommonProjectDataService.getCompanyName();
    this.scheduledDate = this.CommonProjectDataService.getScheduledDate();

    if (!this.ClientName) {
      this.ClientName = this.CommonProjectDataService.getClientId() ? this.CommonProjectDataService.getClientId() : null;
    }

    this.clientFullName = this.ClientName == null || this.ClientName == 'null null' || this.ClientName.includes(null) ? 'Guest' : this.ClientName;
    this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    this.isCustomer = this.userDetails.type == 'Printer' || this.userDetails.type == 'Designer' ? true : false;
    this.projects = JSON.parse(JSON.stringify(this.CommonProjectDataService.get()));
    if (this.projects.projects_data) {
      this.projects.projects_data.forEach((projectValues, projectIndexing) => {
        if (sessionStorage.getItem(`projectTitle_${projectIndexing}`)) {
          this.projects.projects_data[projectIndexing].projectTitle = sessionStorage.getItem(`projectTitle_${projectIndexing}`);
        } else {
          this.projects.projects_data[projectIndexing].projectTitle = projectValues.projectTitle;
        }
      });
    }
    this.storeId = this.projects.store_id ? this.projects.store_id : "";
    if (this.router.url === "/quote/product-list" || this.router.url === "/quote/order" || this.router.url === "/quote/product-quantity") {
      if (Object.keys(this.projects).length === 0) {
        this.projects = JSON.parse(localStorage.getItem("initial-quote"));
      }
      else {
        localStorage.setItem("initial-quote", JSON.stringify(this.CommonProjectDataService.get()));
      }
    }

    if (this.router.url) {
      this.activeLink = this.router.url;
      let urlArr = this.router.url.split("/");
      if (this.orderType == "Quote" || this.orderType == "Invoice" ) {
        this.isShowPayment = true;
      }
      if (this.isPublicQuoteCreation == true) {
        if (urlArr[3]) {
          this.activeLink = urlArr[3];
        }
      }
      else {
        if (urlArr[2]) {
          this.activeLink = urlArr[2];
        }
      }
      this.activeLink = /^\d+$/.test(this.activeLink) == true ? 'order' : this.activeLink;
    }

    this.inkTypeLists = this.CommonProjectDataService.getInkTypeRequest();
    if (this.inkTypeLists && this.inkTypeLists.length > 1) {
      this.isShowInkType = true;
    }
    else {
      this.isShowInkType = false;
    }
    if (this.isShowInkType == false) {
      this.finishingStepNo = (this.finishingStepNo - 1);
      this.finalStepNo = (this.finalStepNo - 1);
    }
    let finishingCount = this.CommonProjectDataService.getFinishingCount();
    if (finishingCount > 0) {
      this.isShowFinishingType = true;
    }
    else {
      this.isShowFinishingType = false;
    }
    if (this.isShowFinishingType == false) {
      this.finalStepNo = (this.finalStepNo - 1);
    }

    if (localStorage.getItem('create_new_quote') === 'true') {
      localStorage.removeItem('create_new_quote');
      localStorage.removeItem('resumeOrder');
      localStorage.removeItem('resumeOrderType');
      let element: HTMLElement = document.getElementById('product_list_button') as HTMLElement;
      element.click();
    }
    this.currentIndexForStep = this.CommonProjectDataService.getCurrentIndexForStep();
    this.previousIndexForStep = this.currentIndexForStep;
    this.activeProjectIndex = this.CommonProjectDataService.getActiveProjectIndex() ? parseInt(this.CommonProjectDataService.getActiveProjectIndex()) : 0;
    this.CommonProjectDataService.storeActiveProjectIndex(this.activeProjectIndex);
    if(!this.isPublicQuoteCreation) {
      this.restoreOrderData();
    }

    if (!this.deliveryDateForPicker && this.scheduledDate) {
      this.deliveryDateForPicker = new Date(this.scheduledDate);
    }
  }

  ngOnChanges() {
    this.projects = JSON.parse(JSON.stringify(this.CommonProjectDataService.get()));
    this.OrderId = this.CommonProjectDataService.getOrderId();
    this.customOrderID = this.CommonProjectDataService.getCustomOrderId();
    if (this.redirectClick === "allProductDeleted") {
      this.redirectToProductList();
    }
  }

  callOwnFunction(name) {
    this.clickOnLink.emit(name);
  }

  redirectToUrl(toUrl) {
    this.checkQtyToUrl = toUrl;
    let isvalidate = this.checkRequired(toUrl);
    this.errorMsg = (this.projects.type == 'Invoice' && this.projects.isInvoiceEditable === 0) && toUrl != 'order' ? "The invoice cannot be edited." : this.errorMsg;
    if (!isvalidate || ((this.projects.type == 'Invoice' && this.projects.isInvoiceEditable === 0) && toUrl != 'order')) {
      this.currentIndexForStep = this.previousIndexForStep;
      this._flashMessagesService.show(this.errorMsg, {
        cssClass: "alert-danger",
        timeout: 5000
      });
    }
    if (toUrl == 'order') {
      this.redirectUrl = isvalidate ? toUrl : null;
    } else{
      this.redirectUrl = (isvalidate && !(this.projects.type == 'Invoice' && this.projects.isInvoiceEditable === 0)) ? toUrl : null;
    }
    if (this.redirectUrl) {
      let orderStatus = this.CommonProjectDataService.getOrderType();
      if (orderStatus == 'Quote'){
        if (!this.storeId && this.projects.type != 'Invoice') {
          this.saveQuoteData();
        }
        if (this.isPublicQuoteCreation == true) {
          return this.router.navigate(['/builder/quote/' + this.redirectUrl]);
        }
        else {
          return this.router.navigate(['/quote/' + this.redirectUrl]);
        }
      }
      else
        if (this.isPublicQuoteCreation == true) {
          return this.router.navigate(['/builder/invoices/' + this.redirectUrl]);
        }
        else {
          return this.router.navigate(['/invoices/' + this.redirectUrl]);
        }
    }
    else {
      return null;
    }
  }

  redirectToProductList() {
    if(!this.isCustomer){
      let orderStatus = this.CommonProjectDataService.getOrderType();
      if (orderStatus == 'Quote') {
        if (this.isPublicQuoteCreation == true) {
          return this.router.navigate(['/builder/quote/product-list']);
        }
        else {
          return this.router.navigate(['/quote/product-list']);
        }
      } else if (orderStatus == 'Invoice' && this.projects.isInvoiceEditable === 1) {
        if (this.isPublicQuoteCreation == true) {
          return this.router.navigate(['/builder/invoices/product-list']);
        }
        else {
          return this.router.navigate(['/invoices/product-list']);
        }
      }
    }
  }

  checkRequired(toUrl) {
    this.errorMsg = null;
    this.activeProjectIndex = this.CommonProjectDataService.getActiveProjectIndex();
    this.projects = JSON.parse(JSON.stringify(this.CommonProjectDataService.get()));
    this.selectedProductColors = this.CommonProjectDataService.getProductColor() ? JSON.parse(JSON.stringify(this.CommonProjectDataService.getProductColor())) : {};
    this.selectedColors = this.CommonProjectDataService.getSelectedColor();
    let isValidate = false;
    switch (toUrl) {
      case 'product-quantity':
        isValidate = this.checkProductInk();
        break;
      case 'print-specs':
        isValidate = this.checkProductInk();
        if (isValidate)
          isValidate = this.checkOrderQuantity();
        break;
      case 'ink-type':
        isValidate = this.checkProductInk();
        if (isValidate)
          isValidate = this.checkOrderQuantity();
        if (isValidate)
          isValidate = this.checkPrintSpec();
        break;
      case 'finishing':
        isValidate = this.checkProductInk();
        if (isValidate)
          isValidate = this.checkOrderQuantity();
        if (isValidate)
          isValidate = this.checkPrintSpec();
        if (isValidate)
          isValidate = this.checkInkType();
        break;
      case 'order':
        const currentUrl = this.router.url;
        const lastSegment = currentUrl.split('/').pop();
        if (lastSegment == 'print-specs') {
          isValidate = this.checkPrintSpec();
        } else {
          isValidate = true;
        }
        break;
    }
    return isValidate;
  }

  checkProductInk() {
    if (this.projects.projects_data[this.activeProjectIndex].products && this.projects.projects_data[this.activeProjectIndex].products.length > 0) {

      if (this.checkQtyToUrl != 'product-quantity') {
        if (this.storeId) {
          if (this.projects.projects_data[this.activeProjectIndex].products.length > 1) {
            this.errorMsg = "Please select only one product in store Quote";
            return false;
          }
          else {
            if (this.projects.projects_data[this.activeProjectIndex].products[0].matrix.length > 1) {
              this.errorMsg = "Please select only one color for product in store Quote";
              return false;
            }
          }
        }
        let totalProjectQuantity = this.projects.projects_data[this.activeProjectIndex].totalProjectQuantity;
        if (totalProjectQuantity <= 0) {
          this.errorMsg = "Please enter product quantity";
          return false;
        }
        else {
          return true
        }
      }
      return true;

    }
    else {
      this.errorMsg = "Please Select at least one product";
      return false;
    }
  }

  checkOrderQuantity() {
    let isQuantityValidated = true;
    this.min_order_qty = this.CommonProjectDataService.getMinOrderQty();
    let totalProjectQuantity = this.projects.projects_data[this.activeProjectIndex].totalProjectQuantity;
    let x = 0;
    this.projects.projects_data[this.activeProjectIndex].products.forEach((mvalue, mkey) => {

      if (isQuantityValidated) {
        let isLessOrderLimit = this.projects.projects_data[this.activeProjectIndex]['products'][mkey].productDetail.less_order_limit;
        var tmp_total_qty = 0;
        let enteredquantity = 0;
        let productDetail = this.projects.projects_data[this.activeProjectIndex]['products'][mkey].productDetail;
        mvalue.matrix.forEach((svalue, skey) => {
          if (isQuantityValidated) {
            svalue.size.forEach((psize, qkey) => {
              if (isQuantityValidated) {
                if (productDetail.title != 'own-garment') {
                  let sizeStock = productDetail.options[svalue.color.color_id][psize.size_id] ? productDetail.options[svalue.color.color_id][psize.size_id]['quantity'] : 0;
                  enteredquantity = svalue.quantity[qkey] ? svalue.quantity[qkey] : 0;
                  if (productDetail.type != 'custom') {
                    isQuantityValidated = true;
                  }
                  else {
                    if (productDetail.type == 'custom' && (sizeStock == '' || sizeStock == 0 || sizeStock == null) && enteredquantity >= 0) {
                      isQuantityValidated = true;
                    }
                    else {
                      if (enteredquantity > 0 && enteredquantity > sizeStock) {
                        this.errorMsg = "Please enter valid Quantity";
                        isQuantityValidated = false;
                      }
                      else {
                        isQuantityValidated = true;
                      }
                    }
                  }
                }
                else {
                  if (enteredquantity > 0) {
                    this.errorMsg = "Please enter valid Quantity";
                    isQuantityValidated = false;
                  }
                  else {
                    isQuantityValidated = true;
                  }
                }
              }
            })
          }
        });

        if (isLessOrderLimit == 1 && isQuantityValidated) {
          if (totalProjectQuantity <= 0) {
            this.errorMsg = "Please enter Quantity";
            isQuantityValidated = false;
            return isQuantityValidated;
          }
        }
        if (isLessOrderLimit == 0 && isQuantityValidated) {
          if ((totalProjectQuantity < this.min_order_qty) && !this.projects.store_id) {
            this.errorMsg = "Total Quantity must be greater than " + this.min_order_qty;
            isQuantityValidated = false;
            return isQuantityValidated;
          }
          else {
            isQuantityValidated = true;
          }
        }
      }
    });
    if (isQuantityValidated) {
      this.handleQuantity(isQuantityValidated);
    }
    return isQuantityValidated;
  }

  checkPrintSpec() {
    let isPrintSpec = true;
    let activeLocationArr = this.projects.projects_data[this.activeProjectIndex].active_location_arr;
    let projectData = this.projects.projects_data[this.activeProjectIndex];
    if (activeLocationArr && activeLocationArr.length > 0) {
      activeLocationArr.forEach((plkey) => {
        if (isPrintSpec) {

          if ((projectData.printPositionSetting && projectData.printPositionSetting[plkey.emblocation_id])
            && (projectData.printPositionSetting[plkey.emblocation_id].printWidth != ''
              && projectData.printPositionSetting[plkey.emblocation_id].printPosition.name != '')

          ) {
            if (projectData.printPositionSetting[plkey.emblocation_id].printType != 'per_color') {
              if (projectData.printPositionSetting[plkey.emblocation_id].printHeight != '') {
                isPrintSpec = true;
              }
              else {
                this.errorMsg = "Please Select print measurements detail";
                isPrintSpec = false;
              }

            }
            else {
              isPrintSpec = true;
            }
            if (projectData.printPositionSetting[plkey.emblocation_id].printType != 'per_item') {
              if (projectData.printPositionSetting[plkey.emblocation_id].printDistance == '' && projectData.printPositionSetting[plkey.emblocation_id].isDistanceOnPortal) {
                this.errorMsg = "Please Select print measurements detail";
                isPrintSpec = false;
              }
              else {
                isPrintSpec = true;
              }
            }
            else {
              isPrintSpec = true;
            }

          }
          else {
            this.errorMsg = "Please Select print measurements detail";
            isPrintSpec = false;

          }
        }
        if (isPrintSpec) {
          if (((projectData.inkColorObj && projectData.inkColorObj[plkey.emblocation_id] && projectData.inkColorObj[plkey.emblocation_id].length > 0)
            || (projectData.printAddonInputSettingObj && projectData.printAddonInputSettingObj[plkey.emblocation_id]
              && Object.keys(projectData.printAddonInputSettingObj[plkey.emblocation_id]).length > 0))) {
            isPrintSpec = true;
          }
          else {
            this.errorMsg = "Please select print spec ink color";
            isPrintSpec = false;
          }
        }
        if (isPrintSpec) {
          if(projectData.printPositionSetting && projectData.printPositionSetting[plkey.emblocation_id] && projectData.printPositionSetting[plkey.emblocation_id].priceMatrix){
            const minMatrixQty = projectData.printPositionSetting[plkey.emblocation_id].priceMatrix.min_order_qty;
            const totalProjectQuantity = projectData.totalProjectQuantity;
            if(totalProjectQuantity < minMatrixQty){
              if (!this.projects.store_id) {
                this.errorMsg = "The total quantity of products for the selected embellishment type must be more than " + minMatrixQty;
                isPrintSpec = false; 
              }
            }
          }
        }
      })
    }
    else {
      this.errorMsg = "Please select ink color for the placement(s).";
      isPrintSpec = false;
    }
    return isPrintSpec;
  }

  checkInkType() {
    if (this.projects.projects_data[this.activeProjectIndex]['ink_Details'] && this.projects.projects_data[this.activeProjectIndex]['ink_Details'].ink_type_id && this.projects.projects_data[this.activeProjectIndex]['ink_Details'].ink_name) {
      return true;
    }
    else {
      this.errorMsg = "Please Select Ink type";
      return false;
    }

  }

  handleQuantity(isQuantityValidated) {
    //default select color when color is not selected
    if (isQuantityValidated && this.projects.projects_data[this.activeProjectIndex] && this.projects.projects_data[this.activeProjectIndex].products.length > 0) {
      //remove products having 0 quantity
      let tempProject = JSON.parse(JSON.stringify(this.projects));
      if (!this.storeId) {
        tempProject.projects_data.forEach((pvalue, pkey) => {
          if (pvalue.products) {
            pvalue.products.forEach((mvalue, mkey) => {
              mvalue.matrix.forEach((svalue, skey) => {
                if (this.totalQuantityCheck(svalue.quantity) == 0) {
                  let product_id = tempProject.projects_data[pkey]['products'][mkey].product_id;
                  let color_id = tempProject.projects_data[pkey]['products'][mkey].matrix[skey].color.color_id;
                  let color_index = tempProject.projects_data[pkey].selectedProductColors[pkey][product_id].indexOf(color_id)
                  tempProject.projects_data[pkey].selectedProductColors[pkey][product_id].splice(color_index, 1);
                  delete tempProject.projects_data[pkey]['products'][mkey].matrix[skey];
                }
              })
              mvalue.matrix = mvalue.matrix.filter(function (el) {
                return el != null;
              });
              if (mvalue.matrix.length == 0) {
                tempProject.projects_data[pkey]['products'].splice(mkey, 1);
              }
            })
          }
        })
      }
      this.projects = tempProject;
      this.CommonProjectDataService.store(this.projects);
    }


  }

  totalQuantityCheck(rowArr) {
    if (Object.keys(rowArr).length > 0) {
      return rowArr.reduce(function (a, b) {
        let aVal = (a) ? a : 0;
        let bVal = (b) ? b : 0;
        return aVal + bVal;
      }, 0);
    }
    else {
      return 0;
    }
  }

  viewClient = function (clientID) {
    if (clientID && this.userDetails.type == 'Shop') {
      this.router.navigate(["/clients/listing/" + clientID]);
    }
  }

  onPrint() {
    window.print();
  }

  NextStep(action) {
    this.previousIndexForStep = this.currentIndexForStep;
    if (action == 'Back') {
      this.currentIndexForStep = (this.currentIndexForStep > 1) ? this.currentIndexForStep - 1 : this.currentIndexForStep;

      const currentUrl = this.router.url;
      const lastSegment = currentUrl.split('/').pop();
      if (lastSegment == 'order') {
        if (!this.isShowInkType && !this.isShowFinishingType) {
          this.currentIndexForStep = 3;
        }
      }
    }
    else if (action == 'Next') {
      this.currentIndexForStep = (this.currentIndexForStep < 6) ? this.currentIndexForStep + 1 : this.currentIndexForStep;
    }
    else {
      this.currentIndexForStep = 6;
    }
    if (this.finalStepNo == 5 && this.currentIndexForStep == 4 && action == 'Back') {
      this.currentIndexForStep = 3;
    }
    switch (this.currentIndexForStep) {
      case 1:
        this.redirectToProductList();
        break;
      case 2:
        this.redirectToUrl('product-quantity');
        break;
      case 3:
        this.redirectToUrl('print-specs');
        break;
      case 4:
        if (this.isShowInkType == true) {
          this.redirectToUrl('ink-type');
        }
        else if (this.isShowFinishingType == true) {
          this.redirectToUrl('finishing');
        }
        else {
          this.redirectToUrl('order');
        }
        break;
      case 5:
        if (this.isShowFinishingType == true) {
          this.redirectToUrl('finishing');
        }
        else {
          this.redirectToUrl('order');
        }
        break;
      case 6:
        this.redirectToUrl('order');
        break;
    }

  }

  addNewProject() {
    this.activeProjectIndex = this.projects.projects_data.length;
    this.CommonProjectDataService.storeActiveProjectIndex(this.activeProjectIndex);
    let sectionData = {
      'section_items': [
        {
          'lable': "Section Title Click to Edit",
          'custom_items': [
            {
              item: "",
              price: "0",
              quantity: "0",
              description: ""
            }

          ]
        }
      ],
      'message_count': 0,
      'totalProjectQuantity': 0,
      'total_printing_price': 0
    }
    // Today changes
    this.CommonProjectDataService.storeProductColor({});
    this.projects.projects_data.push(sectionData);
    this.CommonProjectDataService.store(this.projects);
    this.redirectToProductList();
  }

  activeProject(activeProjectIndex) {
    this.activeProjectIndex = activeProjectIndex;
    this.CommonProjectDataService.storeActiveProjectIndex(this.activeProjectIndex);
    if (this.projects.projects_data[this.activeProjectIndex].selectedProductColors) {
      this.CommonProjectDataService.storeProductColor(this.projects.projects_data[this.activeProjectIndex].selectedProductColors);
    }
    this.NextStep('Current');
  }

  checkedProject(activeProjectIndex, val) {
    this.projects.projects_data[activeProjectIndex].isCheckedProjectTab != val;
    this.CommonProjectDataService.store(this.projects);
  }

  redirectToOrder() {
    let orderStatus = this.CommonProjectDataService.getOrderType();
    let redirectURL = '';
    if (this.isPublicQuoteCreation == true)
      redirectURL = orderStatus == 'Quote' ? '/builder/quote/order' : '/builder/invoices/order';
    else
      redirectURL = orderStatus == 'Quote' ? '/quote/order' : '/invoices/order';
    return this.router.navigate([redirectURL]);
  }

  deleteProject(pkey) {
    if (this.projects.projects_data.length > 1) {
      this.projects.projects_data.splice(pkey, 1);
      this.projects.getPrice = true;
      this.CommonProjectDataService.store(this.projects);
      this.activeProjectIndex = 0;
      this.CommonProjectDataService.storeActiveProjectIndex(this.activeProjectIndex);
      this.redirectToOrder();
    }
    else {
      this._flashMessagesService.show("Deleting all projects is not permitted, as a minimum of one project is necessary to keep your quote creation.", {
        cssClass: "alert-danger",
        timeout: 5000
      });
    }
  }

  duplicateProject(pkey) {
    if (this.projects.projects_data[pkey]) {
      let duplicateData = this.projects.projects_data[pkey];
      this.projects.projects_data.push(duplicateData);
      this.projects.getPrice = true;
      this.CommonProjectDataService.store(this.projects);
      this.activeProjectIndex = this.projects.projects_data.length ? this.projects.projects_data.length - 1 : 0;
      this.CommonProjectDataService.storeActiveProjectIndex(this.activeProjectIndex);
      this.redirectToOrder();
    }
    else {
      this._flashMessagesService.show("Duplicating the project proved to be problematic due to certain issues.", {
        cssClass: "alert-danger",
        timeout: 5000
      });
    }
  }

  renameProject(pkey, projectTitle) {
    if (this.projects.projects_data[pkey]) {
      const newTitle = prompt("Enter new project title", projectTitle);
      if (newTitle) {
        this.projects.projects_data[pkey].projectTitle = newTitle;
        this.CommonProjectDataService.store(this.projects);
        this.projects.getPrice = true;
        sessionStorage.setItem(`projectTitle_${pkey}`, newTitle);
      }
    }
    else {
      this._flashMessagesService.show("Rename the project proved to be problematic due to certain issues.", {
        cssClass: "alert-danger",
        timeout: 5000
      });
    }
  }

  editOrderTitle() {
    this.CommonProjectDataService.store(this.projects);
    this.callOwnFunction('editOrderTitle');
  }

  refreshComponent(dataToRefresh: any) {
    this.customOrderId = dataToRefresh.custom_order_id;
    this.projects.custom_order_id = this.customOrderId;
    this.clientFullName = dataToRefresh.user_full_name ? dataToRefresh.user_full_name : this.clientFullName;
  }

  clickButton(elementDom) {
    let element: HTMLElement = this.elementRef.nativeElement.querySelector(elementDom);
    if (element) {
      element.click();
    }
  }

  printInvoice(invoiceType: string) {
    const printInvoiceData = {
      invoiceType: invoiceType,
      projectData: this.projects
    };
    localStorage.setItem('printInvoiceData', JSON.stringify(printInvoiceData));

    const routePath = `/invoices/print-invoice/${this.projects.order_id}`;
    this.router.navigate([routePath]);
  }

  refreshData() {
    this.projects = JSON.parse(JSON.stringify(this.CommonProjectDataService.get()));
  }

  storeProjectDetails(projectIndex: number) {

    const dialogRef = this.dialog.open(StoreProductPriceComponent, {
      width: "500px",
      data: {
        projects_data: this.projects.projects_data,
        storeId: this.storeId,
        quoteId: this.OrderId,
        projectIndex: projectIndex,
        type: 'Update'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'success') {
        this._flashMessagesService.show("Updated successfully", {
          cssClass: "alert-success",
          timeout: 5000
        });
      }
    });
  }

  restoreOrderData() {
    const currentUrl = this.router.url;
    const urlSegments = currentUrl.split('/');
    const lastSegment = urlSegments[urlSegments.length - 1];

    if (document.readyState != 'complete' && isNaN(Number(lastSegment))) {
      if(localStorage.getItem('resumeOrder') && localStorage.getItem('resumeOrderType')) {
        if (localStorage.getItem('resumeOrderType') === 'Invoice') {
          this.router.navigate([`/invoices/${localStorage.getItem('resumeOrder')}`]);
        } else {
          this.router.navigate([`/quote/${localStorage.getItem('resumeOrder')}`]);
        }
      } else {
        this.router.navigate([`/quotes`]);
      }
    }
  }

  saveQuoteData = function () {
    if (this.projects.totalPriceCalculation) {
      this.projects.projects_data = this.projects.projects_data.map(project => ({
        ...project,
        totalPriceCalculation: true
      }));
    }

    let backgroundOrderId = this.OrderId || this.projects.order_id || localStorage.getItem('backgroundOrderId') || '';
    let clientUserId = this.projects.user_id ? this.projects.user_id : '';
    let saveAction = true;
    if (this.isPublicQuoteCreation) {
      saveAction = false;
      this.isClientUserDetails = (localStorage.getItem('clientUserDetails')) ? JSON.parse(localStorage.getItem('clientUserDetails')) : false;
      if (this.isClientUserDetails && this.isClientUserDetails.user_id) {
        clientUserId = this.isClientUserDetails.user_id;
        saveAction = true;
      }
    }

    if (saveAction) {
      this.quoteData = {
        'id': localStorage.getItem("userID"),
        'user_id': clientUserId,
        'order_id': backgroundOrderId,
        'projects_data': this.projects.projects_data,
        'total_projects': this.projects.total_projects,
        'total_quantity': this.projects.total_quantity,
        'total_weight': this.projects.total_weight,
        'total_products_price': this.projects.total_products_price,
        'total_printing_price': this.projects.total_printing_price,
        'total_price': this.projects.total_price,
        'total_custom_items_price': this.projects.total_custom_items_price,
        'turn_around_time_price': this.projects.turn_around_time_price,
        'shipping_price': this.projects.shipping_price,
        'discount': this.projects.discount,
        'discount_percentage': this.projects.discount_percentage,
        'tax': this.projects.tax,
        'tax_percentage': this.projects.tax_percentage,
        'grand_total_price': this.projects.grand_total_price,
        'delivery_days': this.projects.delivery_days,
        'shipping_method': this.projects.shipping_method_key ? this.projects.shipping_method_key : "local_pickup",
        'turn_around_time': this.projects.turn_around_time_key ? this.projects.turn_around_time_key : 0,
        'shipping_zip': this.projects.shipping_zip ? this.projects.shipping_zip : '',
        'address_id': this.projects.address_id ? this.projects.address_id : '',
        'guest_email': this.projects.guest_email ? this.projects.guest_email : '',
        'one_time_discount_type': this.projects.one_time_discount_type ? this.projects.one_time_discount_type : '',
        'one_time_discount': this.projects.one_time_discount ? this.projects.one_time_discount : 0,
        'one_time_discounted_amt': this.projects.one_time_discounted_amt ? this.projects.one_time_discounted_amt : 0,
        'term_notes': this.projects.term_notes ? this.projects.term_notes : '',
        'order_title': this.projects.order_title ? this.projects.order_title : '',
        'scheduled_date': this.scheduledDate
      };
      
      this.CommonService.apiService(
        "POST",
        "order/save",
        this.quoteData
      ).subscribe(
        (response: any) => {
          if (response.status === true) {
            if (response.data) {
              this.projects.order_id = response.data.order_id;
              localStorage.setItem('backgroundOrderId', this.projects.order_id);
              this.CommonProjectDataService.store(this.projects);
            }
          }
        },
        err => {
        }
      );
    }
  };

  updateDeliveryDateForPicker() {
    if (this.deliveryDateForPicker) {
      const date = new Date(this.deliveryDateForPicker);
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      const year = date.getFullYear();
      this.scheduledDate = `${month}/${day}/${year}`;

      this.deliveryDate = this.scheduledDate;
      this.CommonProjectDataService.storeScheduledDate(this.scheduledDate);
      this.CommonProjectDataService.storeDeliveryDate(this.scheduledDate);
    }
  }  
  
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/add-product-step/add-product-step.component.ts